import { Stack } from "@mui/material";
import { SphereTooltipIcon } from "@components/common/sphere-tooltip-icon";
import { Text, InfoIcon } from "@flat-ui";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { CONSTRAINT_LABEL } from "@src/constants/subscription-constants";
import { constraintTooltips } from "@pages/settings/subscription-settings/usage-metrics/constraint-tooltips";
import { FaroCoreApiTypes } from "@stellar/core-api-client";

interface Props {
  /** The type of the constraint to display */
  type: FaroCoreApiTypes.ConstraintQuotaIdentifier;
}

/** Displays a label for a constraint type with an optional tooltip */
export function ConstraintLabel({ type }: Props): JSX.Element {
  const tooltipLabel = constraintTooltips[type];

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Text variant="bodyM">
        {capitalizeFirstLetter(CONSTRAINT_LABEL[type])}
      </Text>
      {tooltipLabel && (
        <SphereTooltipIcon icon={InfoIcon} text={tooltipLabel} />
      )}
    </Stack>
  );
}
